/**
 * Constants and configuration for location redirect popup module
 * @module location-redirect-popup/constants
 */

/**
 * localStorage key for storing user's location choice
 * @constant {string}
 */
export const STORAGE_KEY = 'location_redirect_choice';

/**
 * Regex pattern to match locale prefix in URL path (e.g., /en-us, /fr-ca)
 * @constant {RegExp}
 */
export const LOCALE_PATTERN = /^\/[a-z]{2}-[a-z]{2}/i;

/**
 * DOM selectors for popup elements
 * @constant {Object}
 */
export const SELECTORS = {
  popup: '#location-redirect-popup',
  markets: '#location-redirect-popup-markets',
  targetCountry: '[data-target-country]',
  redirectBtn: '[data-action="redirect"]',
  stayBtn: '[data-action="stay"]',
  closeBtn: '[data-action="close"]',
  selectLocationBtn: '[data-action="select-location"]',
  countrySelectorModal: '.country_selector-modal',
  welcomePopup: '#location-redirect-popup-welcome',
  welcomeStrings: '#location-redirect-welcome-strings',
  welcomeSubtitle: '[data-welcome-subtitle]',
  currencyNote: '[data-currency-note]',
  shippingNote: '[data-shipping-note]',
  unsupportedLanguagePopup: '#location-redirect-popup-unsupported-language',
  unsupportedLanguageStrings: '#location-redirect-unsupported-language-strings',
  unsupportedLangSubtitle: '[data-unsupported-lang-subtitle]',
  unsupportedLangCurrencyNote: '[data-unsupported-lang-currency-note]',
  returnBtn: '[data-action="return"]',
  footerCountrySelector: '.localization-form__select',
  brandSwitcherNav: '[data-brand-switcher]',
};

/**
 * CSS classes used by the popup
 * @constant {Object}
 */
export const CLASSES = {
  visible: 'is-visible',
};

/**
 * Selector for focusable elements (used for focus trapping)
 * @constant {string}
 */
export const FOCUSABLE = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

/**
 * Custom event dispatched when a confirmed country choice is saved
 * @constant {string}
 */
export const CHOICE_SAVED_EVENT = 'location-redirect-choice-saved';

/**
 * Query parameter added by the server-side redirect from a non-English locale
 * e.g. /es-us/ → 301 → /en-us/?source_locale=es-us
 * @constant {string}
 */
export const SOURCE_LOCALE_PARAM = 'source_locale';

/**
 * Popup display modes
 * @constant {Object}
 */
export const POPUP_MODES = {
  GEOLOCATION: 'geolocation',
  PREVIOUS_SELECTION: 'previous_selection',
  PENDING_CONFIRMATION: 'pending_confirmation',
  UNSUPPORTED_LANGUAGE: 'unsupported_language',
} as const;

export type PopupMode = (typeof POPUP_MODES)[keyof typeof POPUP_MODES];
